var BuyButton          = require("app/Fotocadeau/BuyButton"),
    Dropdown           = require("app/ui/Dropdown"),
    IconButton         = require("app/ui/IconButton"),
    OverlayRightLayout = require("./OverlayRightLayout"),
    TapCommandSupport  = require("app/ui/TapCommandSupport"),
    frameThrottle      = require("enyo-perf/utils").frameThrottle,
    get                = require("object-path").get,
    kind               = require("enyo/kind");

require("./OverlayRight.less");
require("app/theme/IconButton--cta.less");
require("app/theme/IconButton--read-more.less");
require("material-icons/chevron-right.svg");

module.exports = kind(/** @lends  app.MediaPlayer.Tech.ImageViewer.OverlayRight.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.ImageViewer.OverlayRight",

    /**
     * @private
     */
    kind: Dropdown,

    /**
     * @private
     */
    classes: "app-media-player-image-viewer-overlay-right",

    /**
     * @private
     */
    layoutKind: OverlayRightLayout,

    /**
     * Options for the dropdown control
     *
     * @type  {Object=}
     * @public
     */
    dropdownOptions: {
        showCloseButton: false
    },

    /**
     * Whether to show the fotocadeau cta.
     *
     * @type  {bool}
     * @readonly
     * @public
     */
    showFotocadeauCta: null,

    /**
     * Whether to show the description.
     */
    showDescription: null,

    /**
     * Whether to use a short description overlay.
     *
     * @type  {bool}
     * @readonly
     * @public
     */
    useOverlayLeft: null,

    /**
     * @private
     */
    components: [{
        classes:    "app-media-player-image-viewer-overlay-right__content",
        components: [{
            classes: "app-media-player-image-viewer-overlay-right__backdrop"
        }, {
            name:      "description",
            allowHtml: true,
            classes:   "app-media-player-image-viewer-overlay-right__description"
        }, {
            name:          "readMore",
            kind:          IconButton,
            classes:       "app-media-player-image-viewer-overlay-right__read-more",
            mixins:        [TapCommandSupport],
            theme:         "read-more",
            iconAlignment: "right",
            icon:          "chevron-right",
            tapCommand:    "onRequestLongDescription"
        }, {
            name:    "tagline",
            tag:     "p",
            classes: "app-media-player-image-viewer-overlay-right__tagline"
        }, {
            name:          "buyButton",
            kind:          BuyButton,
            classes:       "app-media-player-image-viewer-overlay-right__buy-button",
            theme:         "cta",
            iconAlignment: "right",
            cartIcon:      "chevron-right",
            showCaption:   true
        }]
    }],

    /**
     * @private
     */
    observers: {
        update: ["state", "showDescription", "useOverlayLeft"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.observe("app.$.authService.isLoggedIn", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService  = this.app.$.i18nService,
            state        = this.state || {},
            content      = get(state, "media.meta.html_long_description", null) || "",
            $description = this.$.description,
            $readMore    = this.$.readMore,
            $tagline     = this.$.tagline,
            $buyButton   = this.$.buyButton;

        if (this.get("showDescription") && !this.get("useOverlayLeft")) {
            $description.set("content", content);
            $readMore.set("caption", i18nService.getString("app.MediaPlayer.ImageViewer.readMore"));
            $description.show();
            $readMore.show();
        }
        else {
            $description.hide();
            $readMore.hide();
            $description.set("content", "");
            $description.set("caption", null);
        }

        if (this.get("showFotocadeauCta")) {
            $tagline.set("content", i18nService.getString("app.MediaPlayer.ImageViewer.FotocadeauCta.tagline"));
            $buyButton.set("mediaItem", get(state, "media", null));
            $tagline.show();
            $buyButton.show();
        }
        else {
            $tagline.hide();
            $buyButton.hide();
            $tagline.set("content", "");
            $buyButton.set("mediaItem", null);
        }

        this.reflow();
    },

    /**
     * @protected
     */
    dropdownRevealing: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.reflow();
        };
    })

});
